import { NotFound } from '@systemeio/util'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { TWILIO_INTEGRATION_PATH } from '../api'
import { TwilioIntegrationInterface } from '../types'

export function useTwilioIntegration() {
  const { user } = useUser()
  const { fetcher: fetchIntegration } = useFetch<
    RequestMethodsEnum.get,
    TwilioIntegrationInterface | null
  >({
    method: RequestMethodsEnum.get,
    onErrorBeforeErrorHandlers: error => {
      if (error instanceof NotFound) {
        return null
      }
      throw error
    },
  })

  const { data, mutate, isLoading } = useControlledSwr(() => {
    if (!user) return
    return [TWILIO_INTEGRATION_PATH, RequestModuleEnum.TwilioIntegration]
  }, fetchIntegration)

  return {
    data,
    mutate,
    isLoading,
  }
}
